import { IsNotEmpty, IsOptional, IsString } from 'class-validator';

export class DomainForm {
  @IsString()
  @IsNotEmpty()
  name: string;

  @IsString()
  @IsNotEmpty()
  shortName: string;

  @IsString()
  @IsOptional()
  description?: string | null;
}
